
<app-card [isHeader]=true [title]="'search_filter'|translate">




    <form (ngSubmit)="submit()" [formGroup]="form"  >
      <div class="cp5" fxLayout="row wrap" fxLayoutAlign="start center">
        <div fxFlex="25" fxFlex.lt-md="100">
          <mat-form-field appearance="outline">
            <mat-label>{{"Volume de l'activité"|translate}}</mat-label>
            <mat-select disableOptionCentering formControlName="volume">
              <mat-option  [value]="'Y'">
                {{"PME"|translate}}
              </mat-option>
              <mat-option  [value]="'N'">
                {{"Autre"|translate}}
              </mat-option>
            </mat-select>  
          </mat-form-field>

        </div>

        <div fxFlex="50" fxFlex.lt-md="100">
          <app-combo-commande
          [control]="getFormControl('type_commande')"
          [controlFils]="getFormControl('classification')" 
          [label]="labelcommande|translate" 
          [code]="commmCode.categorieActivite"
          ></app-combo-commande>

        </div>
      </div>

        <div  *ngIf="panelOpenState" class="cp5" fxLayout="row wrap" fxLayoutAlign="start center">
          <div fxFlex="25" fxFlex.lt-md="100">
            <mat-form-field appearance="outline">
              <mat-label>{{"Tout le territoire tunisien"|translate}}</mat-label>
              <mat-select disableOptionCentering formControlName="territoire">
                <mat-option  [value]="'Y'">
                  {{"Oui"|translate}}
                </mat-option>
                <mat-option  [value]="'N'">
                  {{"Non"|translate}}
                </mat-option>
              </mat-select>  
            </mat-form-field>
  
          </div>

          <div fxFlex="25" fxFlex.lt-md="100">
            <app-select-common  *ngIf="getFormControl('territoire').value=='N'" 
            [withfiltre]="true"
            [control]="getFormControl('zone')"
            [label]="'Zone de couverture'"
            (objectZ)="send($event)"
            [code]="'EP32'"
            ></app-select-common>
  
          </div>

          <div fxFlex="25" fxFlex.lt-md="100">
            <app-select-common  *ngIf="getFormControl('territoire').value=='N'" 
            [withfiltre]="true"
            [control]="getFormControl('delegation')"
            [label]="'delegation'"
            [code]="code"
            [withcommonid]="true"
            [disabledcond]="getdiablecond()"
          ></app-select-common>
  
          </div>
  
        </div>




       
       

              <div class="cp5" fxLayout="row wrap" fxLayoutAlign="end end ">
                <div fxFlex="25" fxFlex.lt-md="100">

                </div>
                <div>
                  <button class="btn-blue" mat-flat-button type="submit">
                    <mat-icon>{{ icons.search }}</mat-icon>
                    <span translate>search</span>
                  </button>
          
                  <button style="margin:5px;"
                  (click)="reset()"
                  color="primary"
                  mat-flat-button
                  type="button"
                >
                  <mat-icon>{{ icons.reset }}</mat-icon>
                  <span translate>reset</span>
                </button>

                
                  <a  class="filter-btn"
                  style="background-color: #FFFFFF;
                  "
                  mat-flat-button
                   *ngIf="panelOpenState==true" (click)="panelOpenState=!panelOpenState"  ><mat-icon>remove_circle_outline</mat-icon></a>
                  <a  
                  class="filter-btn"
                  style="background-color: #FFFFFF;
                  "
                  mat-flat-button
                  *ngIf="panelOpenState==false" (click)="panelOpenState=!panelOpenState"  ><mat-icon>add_circle_outline</mat-icon></a>
                </div>
              
              </div>


       
       

   
      

   
       

       


   
     
    </form>
  </app-card>
  
